import { SITE_URL } from "../config/constants";

export const buildArticleJsonLd = (article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: article.title,
  description: article.description,
  image: article.featuredImage,
  datePublished: article.date,
  dateModified: article.updatedAt || article.date,
  author: {
    "@type": "Person",
    name: article.author?.name ?? "",
    jobTitle: article.author?.role ?? "",
    worksFor: {
      "@type": "RealEstateAgent",
      name: "ProNet Real Estate",
      url: SITE_URL,
    },
  },
  publisher: {
    "@type": "RealEstateAgent",
    name: "ProNet Real Estate",
    url: SITE_URL,
    logo: { "@type": "ImageObject", url: `${SITE_URL}/logo-full.webp` },
  },
  mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE_URL}/blog/${article.slug}` },
});

export const buildFaqJsonLd = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});

export const buildBreadcrumbJsonLd = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `${SITE_URL}${c.path}`,
  })),
});

export const buildBlogListJsonLd = (articles) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: articles.map((a, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE_URL}/blog/${a.slug}`,
    name: a.title,
  })),
});

export const formatDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
